import React from 'react';
import { Link } from 'react-router-dom';
import InfoCard from '../../components/InfoCard';
import LiquidContainer from '../../components/LiquidContainer';
import MainLanding from './MainLanding';
import CenteredColumnLayout from '../../components/CenteredColumnLayout';
import SnowBackground from '../../components/SnowBackground';

import agenda from '../../assets/icons/info_evento_icons/agenda_icon.svg';
import clima from '../../assets/icons/info_evento_icons/clima_icon_menu.svg';
import experiencias from '../../assets/icons/info_evento_icons/exp_whis_icon.svg';
import directorio from '../../assets/icons/info_evento_icons/directorio_icon.svg';
import logo from '../../assets/images/logos/copa_logo_white.png'
import links from '../../assets/icons/info_evento_icons/redes_icon.svg';
import recomendaciones from '../../assets/icons/info_evento_icons/recomendaciones_icon.svg';



const sectionsInfo = [
  // {
  //   id: 'eventos',
  //   title: 'Eventos (Agenda)',
  //   content: 'Consulta el calendario oficial del evento',
  //   detail: 'Ver agenda',
  //   image: agenda,
  //   bckGndClr: '#023879'
  // },
  // {
  //   id: 'experiences',
  //   title: 'Experiencias Whistler',
  //   content: 'Descubre actividades y experiencias únicas',
  //   detail: 'Explorar',
  //   image: experiencias,
  //   bckGndClr: '#34646d'
  // },
  {
    id: 'recomendations',
    title: 'Recomendaciones',
    content: 'Sugerencias destacadas para disfrutar tu visita',
    detail: 'Saber más',
    image: recomendaciones ,
    bckGndClr: '#3880f7'
  },
  {
    id: 'directorio',
    title: 'Directorio de Tiendas y Restaurantes',
    content: 'Encuentra restaurantes y tiendas cercanas',
    detail: 'Ver directorio',
    image: directorio,
    bckGndClr: '#174ea0'
  },
  // {
  //   id: 'weather',
  //   title: 'Clima',
  //   content: 'Consulta el clima actual en Whistler',
  //   detail: 'Ver clima',
  //   image: clima,
  //   bckGndClr: '#6ea7ed'
  // },
  // {
  //   id: 'links',
  //   title: 'Redes Sociales Copa Ski 2026',
  //   content: 'Accede a los enlaces oficiales del evento',
  //   detail: 'Ir a links',
  //   image: links,
  //   bckGndClr: '#04163a'
  // }
];


const General = ({ onSelectSection }) => {
  return (
    <MainLanding>
      <SnowBackground />

      <CenteredColumnLayout>
        <img src={logo} style={{maxHeight: "26vh", maxWidth: "210px"}}/>
      </CenteredColumnLayout>

      <div className='px-0'>
        <LiquidContainer backgroundColor="#efefefa7" borderline= "0px">
          <div className='d-flex flex-column justify-content-center align-items-center my-3'>
            
            {sectionsInfo.map((section) => (
              <div key={section.id} className='row w-100 m-0 p-0'>
                <div className="col-12 d-flex justify-content-center align-items-center my-2">
                  <Link to={`/${section.id}`} className="d-block w-100 text-decoration-none text-black">
                  <LiquidContainer backgroundColor="#ffffff" borderline= "0px" radius="10px">
                      <InfoCard
                        imagen={section.image}
                        title={section.title}
                        bckGndClr={section.bckGndClr}
                      />
                  </LiquidContainer>
                  </Link>
                </div>
              </div>
            ))}

          </div>
        </LiquidContainer>
      </div>
    </MainLanding>
  );
};

export default General;
